const DEFAULT_PRODUCTION_ORIGIN = 'https://sadecebilgisayar.com';

/**
 * Canonical public site origin for SEO (Organization JSON-LD, absolute logo URLs).
 * Prefer REACT_APP_PUBLIC_SITE_URL in production builds; never use localhost in static fallbacks.
 */
export function getPublicSiteOrigin(): string {
  const configured = process.env.REACT_APP_PUBLIC_SITE_URL?.trim();
  if (configured) {
    return configured.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    const origin = window.location.origin;
    if (!/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(origin)) {
      return origin.replace(/\/$/, '');
    }
  }
  return DEFAULT_PRODUCTION_ORIGIN;
}

export function buildOrganizationJsonLd(origin: string) {
  const base = origin.replace(/\/$/, '');
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'SadeceBilgisayar',
    url: base,
    logo: `${base}/logo.png`,
  };
}
